module.exports = __webpack_public_path__ + "static/linkedin-f08c524d147f46398cb54013ee7013ee.png";